import { DataGridColumn, useSessionStorageState } from '../../../shared';

type ColumnWithId = DataGridColumn<any, any> & {id: string};

export type StoredTableSettings<F extends { [key: string]: any }> = {
  name: string;
  columns: ColumnWithId[];
  filters?: F;
}

export function useStoredSettings<F>(tableId: string, saved: StoredTableSettings<F>[]) {
  return useSessionStorageState<StoredTableSettings<F>[]>(
    getStoredSettingsStorageKey(tableId),
    [...saved]
  )
}

export const getStoredSettingsStorageKey = (tableId: string) => 'tableSettings_' + tableId
